import { memo } from 'react';
import xw from 'xwind';

import { DEFAULT_VARINAT_OPTION_VALUE } from '@/services/shopify';

interface SelectedOptionsProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'css'> {
  options: any[];
}

function SelectedOptions({
  options,
  ...props
}: SelectedOptionsProps): JSX.Element {
  if (
    !Array.isArray(options) ||
    options.length < 1 ||
    options[0].value === DEFAULT_VARINAT_OPTION_VALUE
  ) {
    return null;
  }

  return (
    <div {...props}>
      {options.map((option) => {
        if (option.value === DEFAULT_VARINAT_OPTION_VALUE) return null;

        return (
          <p key={option.value} css={xw`text-gray-900 mb-1 md:last:mb-0`}>
            {option.name}: {option.value}
          </p>
        );
      })}
    </div>
  );
}

export default memo(SelectedOptions);
